import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { FaqListComponent } from './faq-list/faq-list.component';
import { FaqPageComponent } from './faq-page/faq-page.component';
import { FaqService } from './faq.service';
import { FaqFilterComponent } from './faq-filter/faq-filter.component';
import { FooterModule } from '../footer/footer.module';
import { WindowService } from '../shared/window.service';
import { FaqElement } from './faq-element/faq-element.component';

@NgModule({
  imports: [
    CommonModule, SharedModule, FooterModule
  ],
  declarations: [FaqPageComponent, FaqListComponent, FaqFilterComponent, FaqElement],
  providers: [FaqService, WindowService],
})
export class FaqModule { }



// WEBPACK FOOTER //
// ./ts/app/faq/faq.module.ts